import angular from 'angular';
import angularInview from 'angular-inview';
import OnboardingPage from './pages';

const MODULE_NAME = 'app.onboarding';

angular.module(MODULE_NAME, [angularInview, OnboardingPage]);

export default MODULE_NAME;
